import { AuthContext } from '../context/AuthContext'
import { useContext } from "react"

export const useAuthContext = () => {
    const context = useContext(AuthContext)

    if(!context){
        throw Error("UseAuthContext must be used inside a RoutesContextProvider")
    }

    return context
}